import { Component,  Inject,  Input } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { Task, TaskStatus, taskStatusNames } from 'globals/store/tasks.data';
import { DropdownOption } from 'globals/store/programs.data';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';

const statusDropdownOptions: DropdownOption<TaskStatus>[] = [
  { id: 'open', title: taskStatusNames.open },
  { id: 'inProgress', title: taskStatusNames.inProgress },
  { id: 'reviewing', title: taskStatusNames.reviewing },
  { id: 'complete', title: taskStatusNames.complete },
  { id: 'onHold', title: taskStatusNames.onHold } 
]

@Component({
    selector: 'task-status-dropdown',
    template: `
<dropdown [selected]="statusDropdownOptions | findById:task.status" [selections]="statusDropdownOptions" (select)="changeStatus($event)"></dropdown>
`,
    styleUrls: ['./task-status-dropdown.scss'],
    standalone: true,
    imports: [DropdownComponent, FindByIdPipe]
})
export class TaskStatusDropdownComponent extends Wrapper<TaskStatusDropdownComponent> {
  @Input() task: Task
  statusDropdownOptions = statusDropdownOptions

  changeStatus(selection: DropdownOption<TaskStatus>) {
    console.log({ task: this.task, selection })
    this.taskService.updateStatus(this.task, selection.id)
  }
}

export interface TaskStatusDialogData {
  nTasks: number
}

@Component({
    selector: 'task-status-dropdown-dialog',
    template: `
<dialog-wrapper
  [dialogTitle]="'Set Task Status for ' + data.nTasks + ' Tasks'"
  [tiny]="true"
  [disabled]="false"
  [giveMeTwenty]="true"
  [cancelLeft]="true"
  (cancel)="dialogRef.close()"
  (submit)="dialogRef.close(task.status)"
>
  <dropdown style="margin-bottom: 20px" [selected]="statusDropdownOptions | findById:task.status" [selections]="statusDropdownOptions" (select)="changeStatus($event)"></dropdown>
`,
    styleUrls: ['task-status-dropdown.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, DropdownComponent, FindByIdPipe]
})
export class TaskStatusDropdownDialogComponent {
  statusDropdownOptions = statusDropdownOptions
  task: Partial<Task> = { status: 'open' }

  constructor(
    public dialogRef: MatDialogRef<TaskStatusDropdownDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TaskStatusDialogData,
  ) {}

  changeStatus(selection: DropdownOption<TaskStatus>) {
    this.task.status = selection.id
  }
  
  

}